import styled from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'
import { SansText } from '../SansText/SansText'

export const BlockContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  padding: 2.4rem;
`

export const BackgroundImage = styled(ResponsiveImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const Card = styled.a`
  position: relative;
  display: block;
  width: 100%;
  max-width: 38.5rem;
  aspect-ratio: 4/5;
  @supports not (aspect-ratio: 4/5) {
    margin: 0 1rem;

    &::before {
      float: left;
      padding-top: 125%;
      content: '';
    }

    &::after {
      display: block;
      content: '';
      clear: both;
    }
  }

  &:hover {
    text-decoration: none;

    ${SansText} {
      text-decoration: underline;
      text-decoration-thickness: 0.1rem;
      text-underline-offset: 0.3rem;
    }
  }
`
